import React, { useEffect } from "react"
import PropTypes from "prop-types"

import styles from "./Ad.module.scss"
import { sendGTMEvent } from "../../utils/googleAnalytics"

const Ad = ({ handleClick, number, index, id }) => {
    useEffect(() => {
        window.mmDisplayManager = window.mmDisplayManager || { cmd: [] }

        window.mmDisplayManager.cmd.push(() => {
            window.mmDisplayManager.insertPlacement(
                `my-ad-placeholder-${id}`,
                [[300, 250]],
                "/175840252/fansided.com/Test_Quiz/MultiSize"
            )
        })
    }, [id])

    return (
        <div className={styles.adContainer}>
            <h4>Advertisement</h4>
            <div className={styles.ad} id={`my-ad-placeholder-${id}`} />
            <button
                className={styles.nextButton}
                onClick={() => {
                    sendGTMEvent(
                        "widget next question click",
                        `Next click number=${number}; Ad shown=True`
                    )
                    handleClick(null, null, index)
                }}
            >
                Next Question
            </button>
        </div>
    )
}

Ad.propTypes = {
    handleClick: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    id: PropTypes.string.isRequired,
}

export default Ad
